import {
  ResponsiveContainer,
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
} from "recharts";

export type BarSeries<T> = {
  key: keyof T;
  label: string;
  color: string;
};

interface CustomBarChartProps<T extends object> {
  data: T[];
  xKey: keyof T;
  series: BarSeries<T>[];
  height?: number;
}

const CustomBarChart = <T extends object>({
  data,
  xKey,
  series,
  height = 280,
}: CustomBarChartProps<T>) => {
  return (
    <ResponsiveContainer width="100%" height={height}>
      <BarChart data={data}>
        {/* Gradientes */}
        <defs>
          {series.map((item) => (
            <linearGradient
              key={String(item.key)}
              id={`grad-${String(item.key)}`}
              x1="0"
              y1="0"
              x2="0"
              y2="1"
            >
              <stop offset="0%" stopColor={item.color} stopOpacity={0.9} />
              <stop offset="100%" stopColor={item.color} stopOpacity={0.6} />
            </linearGradient>
          ))}
        </defs>

        <CartesianGrid strokeDasharray="3 3" stroke="#e2e8f0" />

        <XAxis
          dataKey={xKey as string}
          stroke="#94a3b8"
          fontSize={12}
          tickLine={false}
        />

        <YAxis
          stroke="#94a3b8"
          fontSize={12}
          tickLine={false}
          axisLine={false}
        />

        <Tooltip
          contentStyle={{
            backgroundColor: "rgba(255, 255, 255, 0.95)",
            backdropFilter: "blur(10px)",
            border: "1px solid #e2e8f0",
            borderRadius: "12px",
            padding: "12px",
            boxShadow: "0 10px 40px rgba(0,0,0,0.1)",
          }}
        />

        <Legend wrapperStyle={{ paddingTop: 20 }} />

        {series.map((item) => (
          <Bar
            key={String(item.key)}
            dataKey={item.key as string}
            name={item.label}
            fill={`url(#grad-${String(item.key)})`}
            radius={[8, 8, 0, 0]}
            animationDuration={800}
          />
        ))}
      </BarChart>
    </ResponsiveContainer>
  );
};

export default CustomBarChart;
